import {
  CrearCotizacion,
  ActualizarCotizacion,
  BuscarCotizacionActual,
  BuscarCotizacionPorCliente,
  Cargando,
  Error,
} from "../Types/Cotizacion.type";
import { ActualizarCliente } from "./../Types/Login.type";
import {
  firebaseFS,
  firebaseValue,
  firebaseTimeStamp,
} from "../Firebase/FirebaseApp";
import { dispatchController } from "./index.actions";
import { __Colecciones } from "./../environment";
import { format } from "date-fns";

export const crearCotizacion = (productos) => async (dispatch, getState) => {
  try {
    dispatch({
      type: Cargando,
    });

    let { Cliente } = getState().loginReducer;
    let clientePedido = Cliente;

    if (clientePedido.datos.PedidoActual) {
      delete clientePedido.datos.PedidoActual;
    }

    // if (producto.Precio_Formateado) {
    //   delete producto.Precio_Formateado;
    // }

    // if (producto.Total) {
    //   delete producto.Total;
    // }

    productos = productos.map((producto) => {
      if (producto.Precio_Formateado) {
        delete producto.Precio_Formateado;
      }

      if (producto.Total) {
        delete producto.Total;
      }

      return producto;
    });

    const { nanoseconds, seconds } = firebaseTimeStamp.now();
    let fecha = new Date(seconds * 1000 + nanoseconds / 1000000);
    let fechal = format(fecha, "yyyyMMdd'-'HHmmssSS");

    let cotizacion = {
      Codigo: fechal,
      Cliente: clientePedido,
      Productos: productos,
      Estatus: "ACTIVO",
      Fecha_Creacion: firebaseValue.serverTimestamp(),
      Usuario_Creacion: clientePedido,
    };

    const respuestaCreacion = await firebaseFS
      .collection(__Colecciones.Cotizacion)
      .add(cotizacion);

    const idPedido = respuestaCreacion.id;

    const consultaPedido = await firebaseFS
      .collection(__Colecciones.Cotizacion)
      .doc(idPedido);

    await consultaPedido.get().then((doc) => {
      if (doc.exists) {
        Cliente = {
          ...Cliente,
          datos: {
            ...Cliente.datos,
            PedidoActual: {
              id: doc.id,
              datos: doc.data(),
            },
          },
        };
      }
    });

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: [Cliente],
    };

    dispatchController(CrearCotizacion, Error, dispatch, bodyJson);
    dispatchController(ActualizarCliente, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const actualizarCotizacion = (productos) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: Cargando,
    });

    let { Cliente } = getState().loginReducer;
    const { id: idCotizacion } = Cliente.datos.PedidoActual;
    let productosCotizacion = [];

    if (idCotizacion) {
      // if (producto.Precio_Formateado) {
      //   delete producto.Precio_Formateado;
      // }

      // if (producto.Total) {
      //   delete producto.Total;
      // }

      productos = productos.map((producto) => {
        if (producto.Precio_Formateado) {
          delete producto.Precio_Formateado;
        }

        if (producto.Total) {
          delete producto.Total;
        }

        return producto;
      });

      let consultaPedido = await firebaseFS
        .collection(__Colecciones.Cotizacion)
        .doc(idCotizacion);

      await consultaPedido.get().then(async (doc) => {
        if (doc.exists) {
          productosCotizacion = doc.data().Productos;

          productos.forEach((producto) => {
            let posicion = productosCotizacion.findIndex(
              (productoCotizacion) => {
                const { Codigo } = producto;
                const { Codigo: CodigoCotizacion } = productoCotizacion;
                return CodigoCotizacion === Codigo;
              }
            );

            if (posicion < 0) {
              productosCotizacion = [...productosCotizacion, producto];
            } else {
              const { Cantidad } = producto;
              productosCotizacion[posicion] = {
                ...productosCotizacion[posicion],
                Cantidad: Cantidad,
              };
            }
          });

          await firebaseFS
            .collection(__Colecciones.Cotizacion)
            .doc(idCotizacion)
            .update({ Productos: productosCotizacion });

          consultaPedido = await firebaseFS
            .collection(__Colecciones.Cotizacion)
            .doc(idCotizacion);

          await consultaPedido.get().then((doc) => {
            if (doc.exists) {
              Cliente = {
                ...Cliente,
                datos: {
                  ...Cliente.datos,
                  PedidoActual: {
                    id: doc.id,
                    datos: doc.data(),
                  },
                },
              };
            }
          });

          const bodyJson = {
            Resultado: "S",
            Mensaje: "",
            Datos: [Cliente],
          };

          dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
          dispatchController(ActualizarCliente, Error, dispatch, bodyJson);
        } else {
          const bodyJson = {
            Resultado: "N",
            Mensaje: "El pedido no se encuentra registrado.",
            Datos: [],
          };

          dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
        }
      });
    } else {
      const bodyJson = {
        Resultado: "N",
        Mensaje: "El pedido no se encuentra registrado.",
        Datos: [],
      };

      dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
    }
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const anularCotizacion = () => async (dispatch, getState) => {
  dispatch({
    type: Cargando,
  });

  let { Cliente } = getState().loginReducer;
  const { id: idCotizacion } = Cliente.datos.PedidoActual;

  if (idCotizacion) {
    if (Cliente.datos.PedidoActual) {
      delete Cliente.datos.PedidoActual;
    }

    await firebaseFS
      .collection(__Colecciones.Cotizacion)
      .doc(idCotizacion)
      .update({
        Estatus: "ANULADO",
        Fecha_Anulacion: firebaseValue.serverTimestamp(),
        Usuario_Anulacion: Cliente,
      });

    Cliente = {
      ...Cliente,
      datos: {
        ...Cliente.datos,
        PedidoActual: {},
      },
    };

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: [Cliente],
    };

    dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
    dispatchController(ActualizarCliente, Error, dispatch, bodyJson);
  } else {
    const bodyJson = {
      Resultado: "N",
      Mensaje: "El pedido no se encuentra registrado.",
      Datos: [],
    };

    dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
  }
};

export const cerrarCotizacion = (despacho, sucursal) => async (
  dispatch,
  getState
) => {
  dispatch({
    type: Cargando,
  });

  let { Cliente } = getState().loginReducer;
  const { id: idCotizacion } = Cliente.datos.PedidoActual;

  if (idCotizacion) {
    if (Cliente.datos.PedidoActual) {
      delete Cliente.datos.PedidoActual;
    }

    await firebaseFS
      .collection(__Colecciones.Cotizacion)
      .doc(idCotizacion)
      .update({
        Estatus: "CERRADO",
        Fecha_Cierre: firebaseValue.serverTimestamp(),
        Usuario_Cierre: Cliente,
        Despacho: despacho,
        Sucursal: sucursal,
      });

    Cliente = {
      ...Cliente,
      datos: {
        ...Cliente.datos,
        PedidoActual: {},
      },
    };

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: [Cliente],
    };

    dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
    dispatchController(ActualizarCliente, Error, dispatch, bodyJson);
  } else {
    const bodyJson = {
      Resultado: "N",
      Mensaje: "El pedido no se encuentra registrado.",
      Datos: [],
    };

    dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
  }
};

export const eliminarArticuloCotizacion = (producto) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: Cargando,
    });

    let { Cliente } = getState().loginReducer;
    const { id: idCotizacion } = Cliente.datos.PedidoActual;
    let { productos } = [];

    if (idCotizacion) {
      let consultaPedido = await firebaseFS
        .collection(__Colecciones.Cotizacion)
        .doc(idCotizacion);

      await consultaPedido.get().then(async (doc) => {
        if (doc.exists) {
          productos = doc.data().Productos;

          productos = productos.filter(
            (productoCotizacion) =>
              productoCotizacion.Codigo !== producto.Codigo
          );

          await firebaseFS
            .collection(__Colecciones.Cotizacion)
            .doc(idCotizacion)
            .update({ Productos: productos });

          consultaPedido = await firebaseFS
            .collection(__Colecciones.Cotizacion)
            .doc(idCotizacion);

          await consultaPedido.get().then((doc) => {
            if (doc.exists) {
              Cliente = {
                ...Cliente,
                datos: {
                  ...Cliente.datos,
                  PedidoActual: {
                    id: doc.id,
                    datos: doc.data(),
                  },
                },
              };
            }
          });

          const bodyJson = {
            Resultado: "S",
            Mensaje: "",
            Datos: [Cliente],
          };

          dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
          dispatchController(ActualizarCliente, Error, dispatch, bodyJson);
        } else {
          const bodyJson = {
            Resultado: "N",
            Mensaje: "El pedido no se encuentra registrado.",
            Datos: [],
          };

          dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
        }
      });
    } else {
      const bodyJson = {
        Resultado: "N",
        Mensaje: "El pedido no se encuentra registrado.",
        Datos: [],
      };

      dispatchController(ActualizarCotizacion, Error, dispatch, bodyJson);
    }
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const buscarCotizacionActual = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: Cargando,
    });

    let { Cliente } = getState().loginReducer;
    const { id: idCotizacion } = Cliente.datos?.PedidoActual;

    if (idCotizacion) {
      const consultaPedido = await firebaseFS
        .collection(__Colecciones.Cotizacion)
        .doc(idCotizacion);

      await consultaPedido.get().then((doc) => {
        if (doc.exists) {
          Cliente = {
            ...Cliente,
            datos: {
              ...Cliente.datos,
              PedidoActual: {
                id: doc.id,
                datos: doc.data(),
              },
            },
          };

          const bodyJson = {
            Resultado: "S",
            Mensaje: "",
            Datos: [Cliente],
          };

          dispatchController(BuscarCotizacionActual, Error, dispatch, bodyJson);
          dispatchController(ActualizarCliente, Error, dispatch, bodyJson);
        } else {
          const bodyJson = {
            Resultado: "N",
            Mensaje: "El pedido no se encuentra registrado.",
            Datos: [],
          };

          dispatchController(BuscarCotizacionActual, Error, dispatch, bodyJson);
        }
      });
    } else {
      const bodyJson = {
        Resultado: "N",
        Mensaje: "",
        Datos: [],
      };

      dispatchController(BuscarCotizacionActual, Error, dispatch, bodyJson);
    }
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const buscarCotizacionPorCliente = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: Cargando,
    });

    const { id } = getState().loginReducer.Cliente;

    if (id) {
      let cotizaciones = [];

      const consultaPedido = await firebaseFS
        .collection(__Colecciones.Cotizacion)
        .where("Cliente.id", "==", id);

      await consultaPedido.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          cotizaciones = [
            ...cotizaciones,
            {
              id: doc.id,
              datos: doc.data(),
            },
          ];
        });
      });

      const bodyJson = {
        Resultado: "S",
        Mensaje: "",
        Datos: cotizaciones,
      };

      dispatchController(BuscarCotizacionPorCliente, Error, dispatch, bodyJson);
    } else {
      const bodyJson = {
        Resultado: "N",
        Mensaje: "",
        Datos: [],
      };

      dispatchController(BuscarCotizacionActual, Error, dispatch, bodyJson);
    }
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};
